<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles class="title2" title="报税后流程指数分析"></titles>
    <div class="top">
      <div class="topl">
        <div class="paiming active">
          <div class="bg"></div>
          <div class="title">
            得分对比
          </div>
          <div class="line"></div>
        </div>
        <p class="bt">网办对比</p>
        <p class="bt">耗时对比</p>
        <p class="bt2"><span class="kuan"></span> 无法网上办理</p>
      </div>
      <div class="topr">
        <div class="topritem">大连</div>
        <div class="topritem">北京</div>
        <div class="topritem">上海</div>
        <div class="topritem">深圳</div>
      </div>
    </div>
    <div class="bodyx">
      <div class="left">
        <div id="myChart6" :style="{width: '400px', height: '400px'}"></div>
      </div>
      <div class="right">
        <div class="rightitem">
          <div class="rightitem0">退税准备</div>
          <div class="rightitem1">1小时</div>
          <div class="rightitem1 active">1小时</div>
          <div class="rightitem1">1小时</div>
          <div class="rightitem1">1小时</div>
        </div>
        <div class="rightitem">
          <div class="rightitem0">申报退税</div>
          <div class="rightitem1">1.5小时</div>
          <div class="rightitem1">1.5小时</div>
          <div class="rightitem1 active">1.5小时</div>
          <div class="rightitem1">1.5小时</div>
        </div>
        <div class="rightitem">
          <div class="rightitem0">退税准备</div>
          <div class="rightitem1">3.5小时</div>
          <div class="rightitem1 active">3.5小时</div>
          <div class="rightitem1">3.5小时</div>
          <div class="rightitem1">3.5小时</div>
        </div>
        <div class="rightitem">
          <div class="rightitem0">企业所得税申报更正</div>
          <div class="rightitem1">0.5小时</div>
          <div class="rightitem1 active">0.5小时</div>
          <div class="rightitem1">0.5小时</div>
          <div class="rightitem1">0.5小时</div>
        </div>
        <div class="rightitem">
          <div class="rightitem0">必要涉税业务鉴证</div>
          <div class="rightitem1">
            <div class="line"></div>
          </div>
          <div class="rightitem1 active">
            <div class="line"></div>
          </div>
          <div class="rightitem1">
            <div class="line"></div>
          </div>
          <div class="rightitem1">
            <div class="line"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  name: "paiming",
  components: {titles,},
  data: function () {
    return {
      list: [{
        title: '上海',
        day: 1,
        fenshu: 96
      }, {
        title: '大连',
        day: 1,

        fenshu: 96
      }, {
        title: '北京',
        day: 1,

        fenshu: 96
      }, {
        title: '深圳',
        day: 1,
        fenshu: 96
      }]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart6'))
      // 绘制图表
      myChart.setOption({
            tooltip: {
              show: false,
              trigger: 'axis',
              borderWidth: 2,
              textStyle: {
                align: 'left'
              }
            },
            radar: {
              indicator: [{
                name: '大连',
                max: 9
              },
                {
                  name: '北京',
                  max: 9
                },
                {
                  name: '深圳',
                  max: 9
                },
                {
                  name: '上海',
                  max: 8
                }
              ],
              radius: '60%',
              center: ['50%', '50%'],
              shape: 'circle',
              splitNumber: 4,
              name: {
                formatter: function (name, indicator) {
                  indicator.value;
                  return '{a|' + name + '  }{b|' + indicator.max + '}'
                },
                rich: {
                  a: {
                    color: '#ffffff',
                    fontSize: 20
                  },
                  b: {
                    color: 'rgba(66, 192, 227, 1)',
                    fontSize: 20,
                    fontWeight: 700
                  }
                }
              },
              splitArea: {
                areaStyle: {
                  color: [
                    'rgba(255,255,255,0.1)',
                    'rgba(255,255,255,0)',
                    'rgba(255,255,255,0.1)',
                    'rgba(255,255,255,0)'
                  ]
                }
              },
              splitLine: {
                lineStyle: {
                  color: [
                    '#262f53', '#262f53',
                    '#121c44', '#121c44',
                    '#121c44', '#121c44'
                  ].reverse(),
                  width: 10
                }
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(238,238,238, 0.2)'
                }
              }
            },
            series: {
              name: '投资吸引力',
              type: 'radar',
              tooltip: {
                trigger: 'item'
              },
              data: [{
                value: [9, 9, 9, 8],
              }],
              symbol: 'circle',
              symbolSize: 10,
              itemStyle: {
                normal: {
                  color: 'rgba(87,201,255,0.8)',
                  borderColor: 'rgba(87,201,255,0.2)',
                  borderWidth: 5,
                }
              },
              areaStyle: {
                normal: {
                  color: 'rgba(13, 178, 255, 0.3)',
                }
              },
              lineStyle: {
                normal: {
                  color: 'rgba(13, 178, 255, 1)',
                  width: 3
                }
              },
            }
          }
      );
    }
  },
  mounted() {
    this.drawLine();

  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.topr {
  width: 512px;
  height: 55px;
  background: #404A6C;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;

  .topritem {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    width: 25%;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }
}

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  width: 1100px;
  height: 560px;

  .head {
    width: 415px;
    height: 55px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 30%;
      @include flex_center_center();
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item3 {
      width: 40%;
    }
  }
}

.body {
  width: 415px;
  margin: auto;
}

.bodyitem {
  height: 92px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 30%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item3 {
    width: 40%;
  }
}

.biaoti {
  height: 57px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-bottom: 30px;
}

.paimingk {
  @include flex_start_start();
  margin-top: 0px;
}

.paiming4 {
  margin-left: 30px;
  height: 494px;
  width: 660px;
}

.paiming.active {
  position: relative;
  height: 43px;
  margin-right: 26px;

  .title {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    height: 43px;
    position: relative;
    @include flex_start_center();
    padding-left: 13px;
    z-index: 1;
  }

  .line {
    width: 91px;
    height: 11px;
    background: #47CAE9;
    position: absolute;
    bottom: 0;
    left: 43px;
  }

  .bg {
    position: absolute;
    left: 0;
    width: 70px;
    height: 43px;
    top: 0;
    background: #479BAF;
    z-index: 0;
  }
}

.topl {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
}

.bt {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  margin-right: 35px;
}

.bt2 {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  opacity: 0.6;

  span {
    width: 18px;
    height: 21px;
    background: #E57444;
    display: inline-block;
    margin-right: 10px;
  }
}

.bodyx {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;

  .rightitem {
    width: 701px;
    height: 89px;
    background: linear-gradient(0deg, #212B4F 0%, rgba(33, 43, 79, 0.31) 100%);
    border-bottom: 2px solid rgba(129, 134, 155, 1);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;

    .rightitem0 {
      width: 189px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      line-height: 30px;
    }

    .rightitem1 {
      width: 128px;
      height: 89px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #FFFFFF;
      //background: linear-gradient(0deg, #C26041 0%, rgba(229, 116, 68, 0.31) 100%);
    }

    .rightitem1.active {
      background: linear-gradient(0deg, #C26041 0%, rgba(229, 116, 68, 0.31) 100%);
    }
  }
}

.line {
  width: 49px;
  height: 2px;
  background: #FFFFFF;
}

.title2 {
  height: 120px;
}
</style>
